import { get } from '@/Utils/axios'
import axios from 'axios'
import baseUrl from '@/Utils/url.js'

export let instance = axios.create({
  timeout: 100000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    responseType: 'arraybuffer'
  },
  responseType: 'arraybuffer'
})
instance.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem('accessToken')
    if (token) config.headers.common['iot-Auth'] = 'bearer ' + token
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// if (process.env.NODE_ENV === 'production') {
  instance.defaults.baseURL = baseUrl
// }

// 原始原料数据列表查询
export const materialsLog = data => get('/iot-valuation/usermaterialslog/userMaterialsLogPage', data)
// 原料数据列表查询
export const fileDownload = (url, data) =>
  instance.get(url, { params: data }).then(response => {
    console.log('response.headers', response.headers)
    const f = response.headers['Content-Disposition'] || response.headers['content-disposition']
    const type = response.headers['Content-Type'] || response.headers['content-type']
    const fileName = f.match(/filename=(.*)/)[1]
    // 将二进制流转为blob
    const blob = new Blob([response.data], {
      type
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, decodeURI(fileName))
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', decodeURI(fileName))
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    }
  })
// 公司列表查询
export const factoryGet = () => get('/fast-data-analysis/factory/FactoryList')
// 工厂配方营养数据列表获取
export const nutritionGet = data => get('/fast-data-analysis/productnutritionanalysis/list', data)
export const nutritionGet2 = data => get('/fast-data-analysis/productrawanalysis/productList', data)

export const exportFile = data => fileDownload('/fast-data-analysis/formulanutrition/nutritionDataExport', data)
